module.exports = __webpack_public_path__ + "static/media/mask.60b8c74b.svg";